import React from 'react';
import { ShieldCheck, IndianRupee, Award, Headphones, Package, Zap, TrendingUp, MapPin } from 'lucide-react';
import { features } from '../mockData';

export const WhyChooseUsSection = () => {
  const iconMap = {
    0: ShieldCheck,
    1: IndianRupee,
    2: Award,
    3: Headphones,
    4: Package,
    5: Zap,
    6: TrendingUp,
    7: MapPin
  };

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Why Choose FillTech?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Your trusted partner for quality, reliability, and exceptional service
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = iconMap[index];
            return (
              <div
                key={feature.id}
                className="group p-6 bg-gradient-to-br from-white to-gray-50 rounded-xl border border-gray-200 hover:border-blue-300 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-900 transition-colors duration-300">
                  <Icon className="text-blue-900 group-hover:text-white transition-colors duration-300" size={28} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* Trust Badge */}
        <div className="mt-16 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-8 text-center border border-blue-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Trusted Across Kerala
          </h3>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Join hundreds of satisfied businesses, dealers, and customers who trust FillTech for their printer consumables needs. Experience the difference of working with Central Kerala's premier supplier.
          </p>
        </div>
      </div>
    </section>
  );
};
